var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetOnPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 89,
    viewBox: "0 0 77.258 23.548",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-234.88 -18.445)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-33.648 -80.075)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-42.43 -69.507)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10",
    x2: 1,
    gradientTransform: "matrix(-38.886 0 0 38.886 75.649 49.478)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9e106",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79010",
    offset: 0.73768
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79010",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient12",
    x2: 1,
    gradientTransform: "matrix(-36.574 -36.574 -36.574 36.574 65.558 45.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ef2f41",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c80d6b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient15",
    x2: 1,
    gradientTransform: "matrix(29.861 -29.861 -29.861 -29.861 28.821 89.903)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39a36a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc858",
    offset: 0.73696
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cc858",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-99.384 -68.37)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-108.93 -70.361)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath21"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-117.21 -70.361)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-132.05 -70.361)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath27"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-141.06 -61.998)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath29"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-153.42 -60.899)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -8.7372 -32.893)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 313.18 210.45)",
    d: "m0 0h-201.24c-4.077 0-7.382 3.305-7.382 7.382v47.673c0 4.077 3.305 7.383 7.382 7.383h201.24c4.077 0 7.382-3.306 7.382-7.383v-47.673c0-4.077-3.305-7.382-7.382-7.382",
    clipPath: "url(#clipPath2)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 44.865 128.27)",
    d: "m0 0c-3.625 0-6.574-2.949-6.574-6.575v-47.673c0-3.625 2.949-6.574 6.574-6.574h201.24c3.625 0 6.575 2.949 6.575 6.574v47.673c0 3.626-2.95 6.575-6.575 6.575zm201.24-62.438h-201.24c-4.516 0-8.189 3.674-8.189 8.19v47.673c0 4.516 3.673 8.19 8.189 8.19h201.24c4.516 0 8.19-3.674 8.19-8.19v-47.673c0-4.516-3.674-8.19-8.19-8.19",
    clipPath: "url(#clipPath4)",
    fill: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m197.64 33.394h3.001v20.107h-3.001zm27.032 12.865-3.441-8.718h-0.103l-3.569 8.718h-3.234l5.355-12.185-3.053-6.777h3.13l8.252 18.962zm-17.022-10.58c-0.982 0-2.353 0.491-2.353 1.707 0 1.551 1.707 2.147 3.181 2.147 1.32 0 1.941-0.285 2.743-0.673-0.234-1.862-1.837-3.181-3.571-3.181m0.363 11.019c-2.173 0-4.423-0.957-5.355-3.078l2.664-1.112c0.57 1.112 1.63 1.474 2.742 1.474 1.553 0 3.13-0.931 3.157-2.587v-0.207c-0.543 0.311-1.707 0.777-3.13 0.777-2.871 0-5.795-1.578-5.795-4.528 0-2.69 2.354-4.423 4.993-4.423 2.018 0 3.13 0.906 3.828 1.966h0.104v-1.552h2.897v7.709c0 3.569-2.665 5.561-6.105 5.561m-18.547-2.888h-4.269v6.893h4.269c2.244 0 3.517-1.858 3.517-3.446 0-1.559-1.273-3.447-3.517-3.447m-0.077 9.692h-7.192v-20.108h3v7.619h4.192c3.326 0 6.595 2.408 6.595 6.244s-3.269 6.245-6.595 6.245m-39.214-17.827c-2.073 0-3.81 1.736-3.81 4.12 0 2.409 1.737 4.172 3.81 4.172 2.047 0 3.653-1.763 3.653-4.172 0-2.384-1.606-4.12-3.653-4.12m3.445 9.458h-0.103c-0.674 0.802-1.969 1.528-3.602 1.528-3.42 0-6.556-3.006-6.556-6.866 0-3.835 3.136-6.816 6.556-6.816 1.633 0 2.928 0.726 3.602 1.555h0.103v-0.984c0-2.617-1.398-4.017-3.653-4.017-1.84 0-2.98 1.322-3.447 2.437l-2.617-1.089c0.752-1.814 2.747-4.042 6.064-4.042 3.524 0 6.504 2.072 6.504 7.126v12.282h-2.851zm4.924-11.739h3.006v20.107h-3.006zm7.436 6.633c-0.078 2.644 2.047 3.991 3.576 3.991 1.192 0 2.203-0.596 2.54-1.451zm9.329 2.281c-0.571 1.529-2.306 4.353-5.857 4.353-3.523 0-6.451-2.772-6.451-6.841 0-3.835 2.901-6.841 6.788-6.841 3.136 0 4.949 1.918 5.701 3.033l-2.332 1.554c-0.777-1.14-1.84-1.891-3.369-1.891-1.528 0-2.617 0.699-3.316 2.073l9.146 3.782zm-72.873 2.254v-2.902h6.944c-0.207-1.633-0.751-2.824-1.581-3.653-1.01-1.011-2.591-2.125-5.363-2.125-4.276 0-7.618 3.446-7.618 7.721 0 4.276 3.342 7.722 7.618 7.722 2.306 0 3.99-0.907 5.234-2.073l2.047 2.048c-1.736 1.658-4.042 2.927-7.281 2.927-5.856 0-10.78-4.767-10.78-10.624 0-5.855 4.924-10.624 10.78-10.624 3.161 0 5.545 1.037 7.411 2.981 1.917 1.917 2.513 4.612 2.513 6.788 0 0.674-0.052 1.296-0.156 1.814zm17.818-8.887c-2.072 0-3.86 1.71-3.86 4.145 0 2.462 1.788 4.147 3.86 4.147 2.074 0 3.861-1.685 3.861-4.147 0-2.435-1.787-4.145-3.861-4.145m0 10.986c-3.783 0-6.866-2.876-6.866-6.841 0-3.938 3.083-6.841 6.866-6.841 3.784 0 6.867 2.903 6.867 6.841 0 3.965-3.083 6.841-6.867 6.841m14.98-10.986c-2.073 0-3.861 1.71-3.861 4.145 0 2.462 1.788 4.147 3.861 4.147s3.861-1.685 3.861-4.147c0-2.435-1.788-4.145-3.861-4.145m0 10.986c-3.783 0-6.867-2.876-6.867-6.841 0-3.938 3.084-6.841 6.867-6.841 3.784 0 6.867 2.903 6.867 6.841 0 3.965-3.083 6.841-6.867 6.841",
    clipPath: "url(#clipPath6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 56.574 142.36)",
    d: "m0 0c-0.468-0.494-0.744-1.262-0.744-2.258v-35.541c0-0.996 0.276-1.764 0.744-2.258l0.119-0.116 19.909 19.909v0.471l-19.909 19.909z",
    clipPath: "url(#clipPath8)",
    fill: "#72d0f5"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m62.458 49.714v-0.471l6.637-6.639 0.151 0.087 7.863 4.467c2.246 1.276 2.246 3.364 0 4.641l-7.862 4.467-0.15 0.086z",
    fill: "url(#linearGradient10)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m42.43 29.45c0.741-0.784 1.963-0.88 3.34-0.098l23.476 13.339-6.788 6.787z",
    fill: "url(#linearGradient12)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m42.43 69.507 20.028-20.029 6.789 6.788-23.477 13.339c-0.645 0.367-1.257 0.541-1.801 0.541-0.616 0-1.145-0.223-1.539-0.639",
    fill: "url(#linearGradient15)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 132.51 143.88)",
    d: "m0 0c-0.604 0.535-1.4 0.879-2.279 0.879-1.978 0-3.502-1.634-3.502-3.64 0-2.005 1.524-3.625 3.502-3.625 1.702 0 2.938 0.989 3.021 2.555h-2.692v1.112h4.147c0-3.324-1.771-4.889-4.476-4.889-2.692 0-4.78 2.17-4.78 4.847 0 2.693 2.088 4.863 4.78 4.863 1.249 0 2.375-0.482 3.199-1.25z",
    clipPath: "url(#clipPath17)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 145.24 141.22)",
    d: "m0 0v-1.194h-4.326v-3.022h3.777v-1.195h-3.777v-2.857h4.463v-1.194h-5.74v9.462z",
    clipPath: "url(#clipPath19)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 156.28 141.22)",
    d: "m0 0v-1.208h-2.87v-8.254h-1.291v8.254h-2.87v1.208z",
    clipPath: "url(#clipPath21)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m123.34 60.899h-1.277v9.462h1.277z",
    clipPath: "url(#clipPath23)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 176.06 141.22)",
    d: "m0 0v-1.208h-2.87v-8.254h-1.291v8.254h-2.87v1.208z",
    clipPath: "url(#clipPath25)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 188.08 152.37)",
    d: "m0 0c1.991 0 3.516 1.606 3.516 3.611 0 2.006-1.525 3.626-3.516 3.626-1.978 0-3.502-1.62-3.502-3.626 0-2.005 1.524-3.611 3.502-3.611m0 8.474c2.705 0 4.807-2.17 4.807-4.863 0-2.677-2.102-4.847-4.807-4.847-2.691 0-4.779 2.17-4.779 4.847 0 2.693 2.088 4.863 4.779 4.863",
    clipPath: "url(#clipPath27)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 204.56 153.84)",
    d: "m0 0-4.312 7.127v-7.127h-1.277v9.462h1.264l4.27-7.072v7.072h1.278v-9.462z",
    clipPath: "url(#clipPath29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetOnPlayStore);
export default __webpack_public_path__ + "static/media/get-on-play-store.8f2841d38d4dcf5a15fd1da3e3717d9b.svg";
export { ForwardRef as ReactComponent };